import { IdentityReferenceItem } from '@reg/shared/model';

/**
 * Model to a ranking groupAssignment reference item
 */
export class IdentityRankingGroupAssignment extends IdentityReferenceItem {
    public static INSTANCE_OF_NAME: string = 'RankingGroupAssignment';

    public clone(): IdentityRankingGroupAssignment {
        return <IdentityRankingGroupAssignment> super.clone();
    }

    public deserialize(json: Object): IdentityRankingGroupAssignment {
        return <IdentityRankingGroupAssignment> super.deserialize(json);
    }
}
